import React, { useEffect, useState } from 'react';
import { Spinner } from '@economic/taco';
import { useLocalization, t } from '../../l10n/l10n';

export interface LoadingTranslations {
    loadingText1: string;
    loadingText2: string;
    loadingText3: string;
}

export default function SpinnerWithText({ loadingTranslations = undefined }: { loadingTranslations?: LoadingTranslations }) {
    const [text, setText] = useState('');
    const loading = useLocalization(textIds);

    let loadingText1 = t`LOADING_TEXT1`;
    let loadingText2 = t`LOADING_TEXT2`;
    let loadingText3 = t`LOADING_TEXT3`;

    if (loadingTranslations !== undefined) {
        loadingText1 = loadingTranslations.loadingText1;
        loadingText2 = loadingTranslations.loadingText2;
        loadingText3 = loadingTranslations.loadingText3;
    }

    useEffect(() => {
        if (loading) {
            return;
        }

        setText(loadingText1);

        const timeout = setTimeout(() => {
            setText(loadingText2);
        }, 10 * 1000);

        const timeout2 = setTimeout(() => {
            setText(loadingText3);
        }, 60 * 1000);

        return () => {
            clearTimeout(timeout);
            clearTimeout(timeout2);
        };
    }, [loading]);

    return (
        <div className="flex flex-col items-center">
            <Spinner className="w-16 h-16 text-blue-500" />
            <div className="mt-2 mb-4 text-lg font-semibold text-gray-700">{text}</div>
        </div>
    );
}

const textIds = ['LOADING_TEXT1', 'LOADING_TEXT2', 'LOADING_TEXT3'];
